import cn from "classnames";
import React from "react";
import { createUseStyles } from "react-jss";
import { useLocation } from "react-router";
import UILink from "../../ui/UILink";
import { reverse } from "../../urls";
import { AccountContext } from "../../utils/Context";

export default function OldMenu() {
  const styles = legacyStyles();
  const location = useLocation();
  const types = location.pathname.includes("types");

  const brandMenu = (
    <>
      <div className={cn(styles.borderColor, "border-t-2 py-6")}>
        <div className="text-gray-dark uppercase  text-xs">General</div>
        <div className="pl-3 flex flex-col  text-sm">
          <UILink href="/brand/settings#settings" className="py-1.5">
            Settings
          </UILink>
          <UILink href="/brand/settings#team" className="py-1.5">
            Team
          </UILink>
          <UILink href="/brand/settings#billing" className="py-1.5">
            Billing
          </UILink>
        </div>
      </div>
      <div className={cn(styles.borderColor, "border-t-2 py-6")}>
        <div className="text-gray-dark uppercase  text-xs">Integrations</div>
        <div className="pl-3 flex flex-col  text-sm">
          <UILink href="/brand/settings#api" className="py-1.5">
            API
          </UILink>
          <UILink href="/brand/settings#mailchimp" className="py-1.5">
            MailChimp
          </UILink>
          <UILink href="/brand/settings#zapier" className="py-1.5">
            Zapier
          </UILink>
        </div>
      </div>
      <div className={cn(styles.borderColor, "border-t-2 py-6")}>
        <div className="text-gray-dark uppercase  text-xs">Settings</div>
        <div className="pl-3 flex flex-col  text-sm">
          <UILink href="/brand/settings#badges" className="py-1.5">
            Badges
          </UILink>
          <UILink href="/brand/settings#templates" className="py-1.5">
            Certificate Templates
          </UILink>
          <UILink href="/brand/settings#types" className="py-1.5">
            Event Types
          </UILink>
          {types && (
            <>
              <UILink
                href={reverse("brand_settings_knowledge_modules")}
                className="py-1.5"
              >
                Learning modules
              </UILink>
              <span className="py-1.5">License Types</span>
            </>
          )}
          {!types && (
            <>
              <span className="py-1.5">Learning modules</span>
              <UILink
                href={reverse("brand_settings_license_types")}
                className="py-1.5"
              >
                License Types
              </UILink>
            </>
          )}
          <UILink href="/brand/settings#trainer-access" className="py-1.5">
            Trainer Access
          </UILink>
          <UILink href="/brand/settings#price-groups" className="py-1.5">
            Price Groups
          </UILink>
        </div>
      </div>
    </>
  );

  const companyMenu = (
    <>
      <div className={cn(styles.borderColor, "border-t-2 py-6")}>
        <div className="text-gray-dark uppercase  text-xs">General</div>
        <div className="pl-3 flex flex-col  text-sm">
          <UILink href="/company/settings#settings" className="py-1.5">
            Settings
          </UILink>
          <UILink href="/company/settings#payments" className="py-1.5">
            Payments
          </UILink>
          <UILink href="/company/settings#team" className="py-1.5">
            Team
          </UILink>
          <UILink href="/company/settings#billing" className="py-1.5">
            Billing
          </UILink>
        </div>
      </div>
      <div className={cn(styles.borderColor, "border-t-2 py-6")}>
        <div className="text-gray-dark uppercase  text-xs">
          Event management
        </div>
        <div className="pl-3 flex flex-col  text-sm">
          <UILink href="/company/settings#categories" className="py-1.5">
            Categories
          </UILink>
          <UILink href="/company/settings#templates" className="py-1.5">
            Certificate Templates
          </UILink>
          <span className="py-1.5">Email Templates</span>
          <UILink href="/company/settings#evaluation-form" className="py-1.5">
            Evaluation form
          </UILink>
          <UILink href="/company/settings#registration-form" className="py-1.5">
            Registration form
          </UILink>
        </div>
      </div>
      <div className={cn(styles.borderColor, "border-t-2 py-6")}>
        <div className="text-gray-dark uppercase  text-xs">Integrations</div>
        <div className="pl-3 flex flex-col  text-sm">
          <UILink href="/company/settings#api" className="py-1.5">
            API
          </UILink>
          <UILink href="/company/settings#mailchimp" className="py-1.5">
            MailChimp
          </UILink>
          <UILink href="/company/settings#zapier" className="py-1.5">
            Zapier
          </UILink>
        </div>
      </div>
    </>
  );

  return (
    <AccountContext.Consumer>
      {(account) => (
        <>
          {account?.isBrand() && brandMenu}
          {account?.isCompany() && companyMenu}
        </>
      )}
    </AccountContext.Consumer>
  );
}

const legacyStyles = createUseStyles({
  borderColor: {
    borderColor: "#e7e7e7",
  },
});
